import React from "react";
import { DefaultButton, Modal, Label, Stack } from "@fluentui/react";
import { contentStyles, styleLabel, styleDefButton } from "@/screen/Identities/Styles/IdentitiesMainScreenStyles";

export interface ModalSaveSuccessProps
{
    isOpen: boolean;
    onClose: () => void;
}

const ModalSaveSuccess: React.FC<ModalSaveSuccessProps> = ({isOpen, onClose}) =>
{
    return(
        <Modal isOpen={isOpen} onDismiss={onClose}>
            <div className={contentStyles.header}>
                <Label styles={styleLabel}>Cambios guardados</Label>
            </div>
            <div className={contentStyles.body}>
                <p>
                    Los cambios se han guardado correctamente.
                </p>
                <p style={{marginTop: "10px", color: "#95a0a1", fontSize: "14px", cursor: "default"}}>
                    Puedes seguir editando el formulario o finalizar cuando esté completo.
                </p>
            </div>
            <Stack.Item style={{display: "flex", justifyContent: "center", padding: "10px"}}>
                <DefaultButton styles={styleDefButton} onClick={onClose}>
                    Aceptar
                </DefaultButton>
            </Stack.Item>
        </Modal>
    );
};

export default ModalSaveSuccess;